export default __webpack_public_path__ + "static/media/p22.4b5144ef.jpeg";